import { Pronouns } from '@fruitful/member-profile';
import type { ColumnEditorOptions } from 'primereact/column';

import { DropdownEditor } from '../../../common/components/GridCellEditors';

export const PronounsEditor = (options: ColumnEditorOptions) => {
    const pronouns = Object.values(Pronouns);

    return (
        <DropdownEditor
            options={options}
            dropdownProps={{
                options: pronouns,
                placeholder: 'Select Pronouns',
            }}
        />
    );
};
